import useAccessoriesPrice from 'hooks/useAccessoriesPrice';
import { useSelector } from 'react-redux';
import useExtraPackagesPrice from 'hooks/useExtraPackagesPrice';

const useTotalPrice = () => {
  const { builderData, compatibilityData } = useSelector(state => state.data);
  const { specialPrice, price, exteriors, interiors, wheels: wheelsData } = builderData;
  const { priceResolved } = compatibilityData;
  const { colorCode, interior, wheels } = useSelector(state => state.config);

  const accessoriesPrice = useAccessoriesPrice();
  const extraPackagesPrice = useExtraPackagesPrice();

  const findItemPrice = (data, key, code) => {
    const foundItems = data?.filter(item => item?.[key] === code);
    return (foundItems || []).length ? foundItems[0].price : 0;
  };

  if (priceResolved) return priceResolved;

  if (!price || !exteriors || !interiors) return 0;

  return (
    (specialPrice || price) +
    accessoriesPrice +
    extraPackagesPrice +
    findItemPrice(exteriors, 'code', colorCode) +
    findItemPrice(interiors, 'code', interior) +
    findItemPrice(wheelsData, 'code', wheels)
  );
};

export default useTotalPrice;